import React from 'react';

const DariPrototipeKeProdukSolutif: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p className="mb-4">
        Setiap inovasi besar yang mengubah peradaban manusia selalu berawal dari sebuah ide sederhana yang diwujudkan menjadi prototipe uji coba. Namun, dalam perjalanan kompetisi sains dan teknologi, tidak sedikit tim peserta yang memiliki ide brilian namun gagal meraih penghargaan karena tidak mampu menjembatani celah antara konsep di atas kertas dengan prototipe fisik yang berfungsi stabil dan meyakinkan.
      </p>

      <p className="mb-4">
        Dalam ajang <b>Innovative Technology Challenge (ITC)</b>, dewan juri tidak hanya menilai seberapa rumit komponen elektronik atau seberapa panjang baris kode yang ditulis. Penilaian utama difokuskan pada nilai kegunaan produk (<i>utility value</i>), kelayakan implementasi di dunia nyata (<i>feasibility</i>), serta kejelasan metode pengujian data yang dilakukan oleh tim inovator.
      </p>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Empat Tahapan Kunci Menuju Produk Solutif
      </h2>
      <p className="mb-4">
        Berdasarkan evaluasi para dewan juri dan mentor teknologi, berikut adalah metodologi pengembangan proyek yang terbukti mengantarkan inovator muda ke podium juara:
      </p>

      <ol className="list-decimal pl-6 mb-6 space-y-3">
        <li>
          <strong>Validasi Masalah di Lapangan:</strong> Hindari membuat solusi teknologi yang mencari-cari masalah. Lakukan survei atau wawancara langsung kepada pengguna sasaran untuk memahami akar permasalahan sebenarnya yang mereka hadapi.
        </li>
        <li>
          <strong>Pengembangan Prototipe Minimum (MVP):</strong> Bangun versi awal alat yang berfokus pada fungsi inti terlebih dahulu, dengan solderan sirkuit rapi, perlindungan casing yang aman, dan kestabilan daya listrik.
        </li>
        <li>
          <strong>Pengujian Empiris dan Pengumpulan Data:</strong> Lakukan pengujian berulang dalam berbagai kondisi lingkungan nyata. Dokumentasikan metrik performa alat seperti akurasi sensor, kecepatan waktu respons, dan konsumsi daya baterai.
        </li>
        <li>
          <strong>Teknik Presentasi dan Pitching Solutif:</strong> Presentasikan karya dalam alur cerita yang runut: mulai dari latar belakang masalah, demonstrasi alat secara langsung di hadapan juri, hingga estimasi biaya produksi.
        </li>
      </ol>

      <div className="bg-indigo-50 border-l-4 border-indigo-500 p-4 mb-4 rounded-r-lg">
        <p className="text-gray-800 text-sm">
          <b>&quot;Inovasi bukan sekadar merakit sensor canggih, melainkan bagaimana teknologi tersebut dapat menyederhanakan kehidupan manusia dan memecahkan persoalan nyata secara terukur.&quot;</b>
        </p>
      </div>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Membangun Pola Pikir Wirausaha Teknologi
      </h2>
      <p className="mb-4">
        Melalui ajang <i>Innovative Technology Challenge</i>, peserta dilatih untuk memandang karya rekayasa mereka dari sudut pandang <i>technopreneurship</i>. Mereka tidak hanya belajar menjadi insinyur yang handal, melainkan juga perintis masa depan yang mampu mengkomunikasikan nilai inovasi, mengelola sumber daya, dan membawa dampak positif bagi kemajuan bangsa.
      </p>
    </div>
  );
};

export default DariPrototipeKeProdukSolutif;
